import { useEffect, useRef, useState } from 'react';

/**
 * Renders children only when near the viewport (defers JS + images below the fold).
 */
export default function DeferredSection({ children, minHeight = 280, rootMargin = '280px' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div ref={ref} className="t8-deferred" style={visible ? undefined : { minHeight }}>
      {visible ? children : <div className="t8-deferred__placeholder" aria-hidden style={{ minHeight }} />}
    </div>
  );
}

export function RouteFallback() {
  return (
    <div className="t8-route-fallback" role="status" aria-live="polite">
      Loading…
    </div>
  );
}
